export default [
    {
        path: '/asset/asset-category',
        name: 'asset-category',
        props: true,
        component: () => import('@/views/asset/asset-category/index.vue'),
        meta: {
            pageTitle: 'Asset Category',
            breadcrumb: [
                {
                text: 'Asset Category',
                active: true,
                },
            ],
        },
    },
    {
        path: '/asset/asset-category/add',
        name: 'create-asset-category',
        component: () => import('@/views/asset/asset-category/create.vue'),
        meta: {
            pageTitle: 'Create Asset Category',
            breadcrumb: [
                {
                text: 'Asset Category',
                to: { name: 'asset-category' },
                },
                {
                text: 'Create Asset Category',
                active: true,
                },
            ],
        },
    },
    {
        path: '/asset/asset-category/:id',
        name: 'detail-asset-category',
        props: true,
        component: () => import('@/views/asset/asset-category/detail.vue'),
        meta: {
            pageTitle: 'Detail Asset Category',
            breadcrumb: [
                {
                text: 'Asset Category',
                to: { name: 'asset-category' },
                },
                {
                text: 'Detail Asset Category',
                active: true,
                },
            ],
        },
    },
]